import { isDevelopmentEnvironment } from "@/lib/is-development-environment";

const OVH_BUCKET_PREFIX_BY_HOST: ReadonlyMap<string, string> = new Map([
  ["implement-stg-ark-climate.s3.de.io.cloud.ovh.net", "stg"],
  ["implement-prd-ark-climate.s3.de.io.cloud.ovh.net", "prd"],
]);

const PROXY_PATH = "/s3-proxy";

export const getProxiedImageUrl = (originalUrl: string | null | undefined): string => {
  if (!originalUrl) {
    return "";
  }

  if (isDevelopmentEnvironment()) {
    return originalUrl;
  }

  try {
    const url = new URL(originalUrl);
    const bucketPrefix: string | undefined =
      url.protocol === "https:" ? OVH_BUCKET_PREFIX_BY_HOST.get(url.hostname) : undefined;
    return bucketPrefix === undefined ? originalUrl : `${PROXY_PATH}/${bucketPrefix}${url.pathname}`;
  } catch {
    return originalUrl;
  }
};
